import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetAircallIntegrationIsEnabledForInstance as SetAircallIntegrationIsEnabledForInstanceMutation,
    SetAircallIntegrationIsEnabledForInstanceVariables,
} from 'nutshell-graphql-types';

import SET_AIRCALL_INTEGRATION_IS_ENABLED_FOR_INSTANCE from '../mutations/set-aircall-integration-is-enabled-for-instance.graphql';

export const useSetAircallIntegrationIsEnabledForInstance = (): {
    setAircallIntegrationIsEnabledForInstance: (arg1: boolean) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setAircallIntegrationIsEnabledForInstance, {loading, error}] = useMutation<
        SetAircallIntegrationIsEnabledForInstanceMutation,
        SetAircallIntegrationIsEnabledForInstanceVariables
    >(SET_AIRCALL_INTEGRATION_IS_ENABLED_FOR_INSTANCE);

    return {
        setAircallIntegrationIsEnabledForInstance: (isEnabled: boolean) =>
            setAircallIntegrationIsEnabledForInstance({variables: {isEnabled}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
